import { makeStyles, Theme, createStyles, DrawerProps, Hidden, Drawer } from '@material-ui/core'
import React, { useState } from 'react'
import { ReactFC } from '../types'

export const useAppDrawerStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: theme.appDrawer.width
        },
        nested: {
            paddingLeft: theme.spacing(4),
        },
    }),
)

export const useDrawer = () => {
    const [open, setOpen] = useState<boolean>()
    const toggleDrawer = (vis: boolean) => () => setOpen(vis)
    return { toggleDrawer, open }
}

export const CircleDesktopDrawer: ReactFC<DrawerProps & {menu: React.ReactNode}> = ({menu, children}) => {
    return (
        <>
            <Hidden smUp>
                <Drawer
                    variant="temporary"
                    anchor='left'

                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}                    
                >{menu}</Drawer>
            </Hidden>
            <Hidden xsDown implementation="css">
                {children}
            </Hidden>
        </>
    )
}
